
import { computed, defineComponent } from 'vue'

export default defineComponent({
    name: 'TgToggle',
    props: {
        modelValue: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['update:modelValue'],
    setup (props, { emit }) {
        const value = computed({
            get () {
                return props.modelValue
            },
            set (value) {
                emit('update:modelValue', value)
            }
        })

        return { value }
    }
})
